"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAnonymousObjectExpression = exports.getAnonymousListExpression = exports.getStringExpression = exports.getFloatExpression = exports.getIntExpression = exports.getBooleanExpression = exports.getBooleanIfExpression = exports.getNoOpExpression = exports.getAnonymousExpression = void 0;
const reductionLogs_1 = require("./reductionLogs");
const uniqueId_1 = __importDefault(require("./uniqueId"));
// When modifying expression constructors, ensure that they properly thread
// through optional fields like isTransient and don't accidentally drop them
function getAnonymousExpression(value, isTransient) {
    if (typeof value === "boolean") {
        return getBooleanExpression(value, isTransient);
    }
    if (typeof value === "number") {
        if (Number.isInteger(value)) {
            return getIntExpression(value, isTransient);
        }
        return getFloatExpression(value, isTransient);
    }
    if (typeof value === "string") {
        return getStringExpression(value, isTransient);
    }
    if (Array.isArray(value)) {
        return getAnonymousListExpression(value, isTransient);
    }
    if (typeof value === "object") {
        return getAnonymousObjectExpression(value, isTransient);
    }
    const neverValue = value;
    throw new Error(`Unexpected value: ${neverValue}`);
}
exports.getAnonymousExpression = getAnonymousExpression;
function getNoOpExpression(isTransient) {
    const expression = {
        id: (0, uniqueId_1.default)(),
        isTransient,
        logs: (0, reductionLogs_1.getEmptyLogs)(),
        type: "NoOpExpression",
        valueType: { type: "VoidValueType" },
    };
    return expression;
}
exports.getNoOpExpression = getNoOpExpression;
function getBooleanIfExpression(value, isTransient) {
    const expression = {
        id: (0, uniqueId_1.default)(),
        isTransient,
        logs: (0, reductionLogs_1.getEmptyLogs)(),
        type: "SwitchExpression",
        valueType: { type: "BooleanValueType" },
        control: getBooleanExpression(true),
        cases: [],
        default: getBooleanExpression(value, isTransient),
    };
    return expression;
}
exports.getBooleanIfExpression = getBooleanIfExpression;
function getBooleanExpression(value, isTransient) {
    const expression = {
        id: (0, uniqueId_1.default)(),
        isTransient,
        logs: (0, reductionLogs_1.getEmptyLogs)(),
        type: "BooleanExpression",
        valueType: { type: "BooleanValueType" },
        value,
    };
    return expression;
}
exports.getBooleanExpression = getBooleanExpression;
function getIntExpression(value, isTransient) {
    const expression = {
        id: (0, uniqueId_1.default)(),
        isTransient,
        logs: (0, reductionLogs_1.getEmptyLogs)(),
        type: "IntExpression",
        valueType: { type: "IntValueType" },
        value: Math.round(value),
    };
    return expression;
}
exports.getIntExpression = getIntExpression;
function getFloatExpression(value, isTransient) {
    const expression = {
        id: (0, uniqueId_1.default)(),
        isTransient,
        logs: (0, reductionLogs_1.getEmptyLogs)(),
        type: "FloatExpression",
        valueType: { type: "FloatValueType" },
        value,
    };
    return expression;
}
exports.getFloatExpression = getFloatExpression;
function getStringExpression(value, isTransient) {
    const expression = {
        id: (0, uniqueId_1.default)(),
        isTransient,
        logs: (0, reductionLogs_1.getEmptyLogs)(),
        type: "StringExpression",
        valueType: { type: "StringValueType" },
        value,
    };
    return expression;
}
exports.getStringExpression = getStringExpression;
function getAnonymousListExpression(value, isTransient) {
    const expression = {
        id: (0, uniqueId_1.default)(),
        isTransient,
        logs: (0, reductionLogs_1.getEmptyLogs)(),
        type: "ListExpression",
        valueType: {
            type: "ListValueType",
            itemValueType: { type: "VoidValueType" },
        },
        items: value.map((item) => getAnonymousExpression(item, isTransient)),
    };
    return expression;
}
exports.getAnonymousListExpression = getAnonymousListExpression;
function getAnonymousObjectExpression(value, isTransient) {
    const objectTypeName = ""; // Dummy
    const expression = {
        id: (0, uniqueId_1.default)(),
        isTransient,
        logs: (0, reductionLogs_1.getEmptyLogs)(),
        type: "ObjectExpression",
        valueType: { type: "ObjectValueType", objectTypeName },
        objectTypeName,
        fields: Object.fromEntries(Object.entries(value).map(([fieldName, fieldValue]) => [
            fieldName,
            getAnonymousExpression(fieldValue, isTransient),
        ])),
    };
    return expression;
}
exports.getAnonymousObjectExpression = getAnonymousObjectExpression;
//# sourceMappingURL=expression.js.map